
  export default {
    name: 'AppScreenAnimation',
    data() {
      return {
      }
    }
  }
